export default __webpack_public_path__ + "static/media/background.46d56ed1.jpg";